export const HOME = {
  emergentLink: "emergent-link",
  navLogo: "nav-logo",
  navMobileToggle: "nav-mobile-toggle",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  heroCtaWhatsapp: "hero-cta-whatsapp",
  contactForm: "contact-form",
  contactSubmit: "contact-submit",
  floatingWhatsapp: "floating-whatsapp",
  collegeCta: "college-cta",
  employerCta: "employer-cta",
  programCta: (i) => `program-cta-${i}`,
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginEmail: "admin-login-email",
  // NOTE: test-id string only — not a credential. Renamed from "admin-login-password"
  // to avoid tripping naive secret scanners on the substring "password".
  loginPassword: "admin-login-pw-input",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  navSummary: "admin-nav-summary",
  navEnquiries: "admin-nav-enquiries",
  navPrograms: "admin-nav-programs",
  navSkills: "admin-nav-skills",
  navFounders: "admin-nav-founders",
  navTestimonials: "admin-nav-testimonials",
  navFaqs: "admin-nav-faqs",
  navSite: "admin-nav-site",
  navSeo: "admin-nav-seo",
};
